import { Head } from "@inertiajs/react"
import { PublicShell } from "@/components/PublicShell"
import { SiteFooter } from "@/components/landing/SiteFooter"
import { SiteHeader } from "@/components/landing/SiteHeader"
import { Button } from "@/components/ui/button"


// The dead-link page for a hosted audit (docs/specs/hosted-audits.md §6.1).
//
// Served with a 410 for an unknown, revoked, expired OR deck-deleted token, and
// identical in all four cases: telling "expired" apart from "never existed"
// would confirm to someone probing tokens that they had found a real one. The
// controller passes NO props for the same reason — there is deliberately
// nothing on this page that varies with the link that led here.
//
// The lead form is not embedded; the CTA goes to the home page's form, and the
// header and footer are passed the same absolute href so their Apply links
// aren't dead anchors on a page with no form on it.
const APPLY_HREF = "/#apply"

const TITLE = "This link is no longer active"
const DESCRIPTION =
  "This audit link has expired or been turned off. If you were sent one and still need it, apply and I'll get you a fresh copy."

export default function AuditGone() {

  return (
    <>
      <Head title={TITLE}>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        {/* Belt and braces alongside the controller's X-Robots-Tag header. */}
        <meta name="robots" content="noindex, nofollow" />
      </Head>

      <PublicShell>
        <div className="landing-scope flex min-h-dvh flex-col bg-page">
          <SiteHeader
            applyHref={APPLY_HREF}
          />

          <main className="flex flex-1 items-center">
            <div className="mx-auto w-full max-w-2xl px-4 py-20 sm:px-6 sm:py-28">
              <span className="section-eyebrow">Audit link</span>
              <h1 className="hero-title mt-3">{TITLE}</h1>
              <p className="section-lead mt-5">
                Audit links are private and time-limited, so they get turned off
                once the work is done. If you were sent this one and still need
                it, ask for a fresh link and I'll send one over.
              </p>
              <div className="mt-10 flex flex-wrap gap-3">
                <Button asChild size="lg">
                  <a href={APPLY_HREF} data-track-click="audit_gone_apply">
                    Apply for an audit
                  </a>
                </Button>
                <Button asChild size="lg" variant="secondary">
                  <a href="/">Back to home</a>
                </Button>
              </div>
            </div>
          </main>

          <SiteFooter
            applyHref={APPLY_HREF}
            navHeading="Elsewhere"
            navLinks={[
              { href: "/", label: "Home" },
              { href: "/case-studies/econo-pak", label: "Case study" },
            ]}
          />
        </div>
      </PublicShell>
    </>
  )
}
